import {EntityType} from "../@core/entityType";
import {Operation} from "reactcoregk";

export const entityType = EntityType.Client;
export const entityOperations = [
  Operation.getAll,
  Operation.create,
  Operation.update,
  Operation.delete,
];
